import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function EmptyState({
  title,
  detail,
  action,
  className,
}: {
  title: string;
  detail?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-16 text-center',
        className,
      )}
    >
      <div className="label-xs text-ink-dim">{title}</div>
      {detail ? <p className="max-w-sm text-xs text-ink-faint">{detail}</p> : null}
      {action}
    </div>
  );
}

/** Indeterminate progress bar — reads as a scanning instrument, not a spinner. */
export function Sweep({ className }: { className?: string }) {
  return (
    <div className={cn('h-px w-full overflow-hidden bg-line', className)}>
      <div className="h-full w-1/3 animate-sweep bg-accent" />
    </div>
  );
}

export function SkeletonRow({ className }: { className?: string }) {
  return <div className={cn('h-3 animate-pulse rounded-sharp bg-raised', className)} />;
}

export function ErrorState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      <div className="label-xs text-alert">Fault</div>
      <p className="max-w-md font-mono text-xs text-ink-dim">{message}</p>
      {action}
    </div>
  );
}
